import * as actionTypes from './actionTypes';
import { TypeOperationModel } from '@app/src/views/StepOne/form';

interface State {
  data: TypeOperationModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const typeOperation = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_TYPE_OPERATION_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_TYPE_OPERATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_TYPE_OPERATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.CLEAR_TYPE_OPERATION_DATA:
      return {
        ...state,
        data: []
      }
    default:
      return state;
  }
}
